import {
  faHeart,
  faLocationDot,
  faInr,
} from "@fortawesome/free-solid-svg-icons";
import { useState, useEffect } from "react";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useUser } from "../context/UserContext";
import { useBuyWishlist } from "../context/BuyContext";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Link } from "react-router-dom";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination } from "swiper/modules";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { useLoginModal } from "../context/LoginPopUpContext";
const BuyPropertyCard = ({
  property,
  flatId,
  showMetaDetails = true,
  hideWishList = true,
}) => {
  const itemId = property.propertyGuid;
  const { user } = useUser();
  const { wishlist, addToBuyWishlist, removeFromBuyWishlist } =
    useBuyWishlist();

  const [isWishlisted, setIsWishlisted] = useState(false);

  //this one is if user not log in then shoe the login
  const { openLogin } = useLoginModal();

  useEffect(() => {
    if (property && property.id) {
      setIsWishlisted(property?.wishList?.toLowerCase() === "yes" || false);
    }
  }, [property]);

  useEffect(() => {
    // Check if item is already in the wishlist
    setIsWishlisted(wishlist?.some((item) => item.propertyGuid === itemId));
  }, [user, itemId, wishlist]);

  const handleWishlist = async (event) => {
    event.stopPropagation();
    event.preventDefault();

    if (!user.isAuthenticated) {
      // toast.error("Please log in to add items to your wishlist.");
      // instead of tost here we are giving the popup form for login
      openLogin({ actionName: "addtoWishList", FlatId: itemId });
      return;
    }

    if (isWishlisted) {
      const wishListItem = wishlist.find(
        (item) => item.propertyGuid === itemId,
      );
      if (wishListItem) {
        await removeFromBuyWishlist(wishListItem.id);
      }
    } else {
      await addToBuyWishlist(itemId);
    }
    setIsWishlisted(!isWishlisted); // Toggle wishlist state locally if authenticated
  };

  return (
    <div className="buy-property-card buy-module">
      <div className="wishlist-icon z-2" onClick={handleWishlist}>
        <FontAwesomeIcon
          icon={faHeart}
          style={{
            color: isWishlisted && user.isAuthenticated ? "red" : "gray",
          }}
        />
      </div>

      <div className="property-image">
        {property.gallery && property.gallery.length > 0 ? (
          <Swiper
            slidesPerView={1}
            modules={[Pagination]}
            pagination={{ clickable: true }}
            lazy={true}
            className="property-card-swiper"
          >
            {/* //dont show the video in property card */}
            {property.gallery
              .filter((item) => item.fileType == "Image")
              .map((propertyImage, index) => (
                <SwiperSlide key={index} className="property-card-slider">
                  <Link
                    to={`/buy/detail/${property.propertyListingNameUrl}-${flatId}`}
                    target="_blank"
                  >
                    <LazyLoadImage
                      className="img-fluid"
                      alt={property.flatName || "property"}
                      src={propertyImage.fileLink}
                      width={500}
                      height={180}
                      effect="blur"
                    />
                  </Link>
                </SwiperSlide>
              ))}
          </Swiper>
        ) : (
          <Link
            to={`/buy/detail/${property.propertyListingNameUrl}-${flatId}`}
            target="_blank"
          >
            <img src={property.image} alt={property.propertyName} />
          </Link>
        )}
      </div>
      <Link
        to={`/buy/detail/${property.propertyListingNameUrl}-${flatId}`}
        target="_blank"
        className="h-100"
      >
        <div className="card-content">
          {property.propertyListingName ? (
            <h3>{property.propertyListingName}</h3>
          ) : (
            <h3>{property.propertyName}</h3>
          )}

          <div className="property-location">
            <FontAwesomeIcon icon={faLocationDot} />
            <span>
              {property.propertyLocation}, {property.city}
            </span>
          </div>

          <div className="property-meta-info">
            <span className="property-type">
              {property?.bhkTypes?.filter((bhk) => bhk).length > 0 && (
                <>
                  {property.bhkTypes
                    .filter((bhk) => bhk)
                    .map((bhk) => bhk.replace(/BHK/i, "").trim())
                    .join(", ")}{" "}
                  BHK{" "}
                </>
              )}
              {property.propertyType}
            </span>

            {property.builder && (
              <span className="property-developer">{property.builder}</span>
            )}
          </div>

          <div className="buy-property-price">
            <FontAwesomeIcon icon={faInr} /> {property.priceRange}
          </div>
        </div>
      </Link>
    </div>
  );
};

export default BuyPropertyCard;
